module.exports = __webpack_public_path__ + "static/media/add_icon.356ae1d7.svg";